module.exports = __webpack_public_path__ + "static/media/13.b091398d.png";